import { hasSupervisorPermission } from '@heyjob-dash/shared/utils/check-permission';
import { MODULE_FLAGS, PREVIEW_FLAGS, isModuleEnabled, isPreviewEnabled } from '@heyjob-dash/shared/config/company-modules';

import { getProductGuides } from './index';

// Ogni guida si vede solo a chi vede la pagina: stesse regole delle voci di menu
// (layouts/dashboard/config-navigation*.jsx) e delle guardie delle rotte.
// Se il menu cambia, queste regole vanno riallineate.
const RULES = {
  cartellino: ({ user, groups, company }) =>
    isModuleEnabled(company, MODULE_FLAGS.TIMESHEET) &&
    groups.some((group) => ['Azienda', 'Responsabile', 'Timesheet'].includes(group)) &&
    (hasSupervisorPermission(user, 'timesheet_view') || groups.includes('Timesheet')),
  anagrafiche: ({ user, groups }) => groups.includes('Azienda') || hasSupervisorPermission(user, 'registry_access'),
  documenti: ({ groups, company }) => groups.includes('Azienda') && isModuleEnabled(company, MODULE_FLAGS.DOCUMENTS),
  richieste: ({ user, groups, company }) =>
    !!company?.feature_requests && (hasSupervisorPermission(user, 'requests_view') || groups.includes('Timesheet')),
  'note-spese': ({ user, company }) => !!company?.feature_expense_reports && hasSupervisorPermission(user, 'expenses_view'),
  report: ({ user, company }) => hasSupervisorPermission(user, 'report_access') && isModuleEnabled(company, MODULE_FLAGS.REPORTS),
  trasparenza: ({ user, groups, company }) =>
    groups.includes('Azienda') &&
    hasSupervisorPermission(user, 'report_access') &&
    isModuleEnabled(company, MODULE_FLAGS.REPORTS) &&
    isPreviewEnabled(company, PREVIEW_FLAGS.PAY_TRANSPARENCY),
};

export function canSeeGuide(guide, user) {
  const rule = RULES[guide?.slug];
  if (!user || !rule) {
    return false;
  }
  const companyId = user.data?.current_company;
  return rule({ user, groups: user.groups ?? [], companyId, company: user.data?.companies?.[companyId] });
}

// Le pagine delle guide (News) sono riservate al ruolo Azienda: gli altri vedono solo il tour.
export function canOpenGuide(guide, user) {
  return (user?.groups ?? []).includes('Azienda') && canSeeGuide(guide, user);
}

export function getVisibleGuides(user) {
  return getProductGuides().filter((guide) => canSeeGuide(guide, user));
}

// Guida successiva tra quelle che l'utente può vedere; null se non ce ne sono altre.
export function getNextGuide(slug, user) {
  const catalog = getProductGuides();
  const index = catalog.findIndex((guide) => guide.slug === slug);
  const following = [...catalog.slice(index + 1), ...catalog.slice(0, index)];
  return following.find((guide) => canSeeGuide(guide, user)) ?? null;
}
